const creatorHub = [
	// Agency Settings
	{
		path: '/agency/settings',
		name: 'agency-settings',
		component: () => import('@/views/agency/agency-settings/index.vue'),
		meta: { layout: 'content', module: 'MGAG,creator-hub' },
	},

	// Contract Templates
	{
		path: '/agency/contract-templates',
		name: 'agency-contract-templates-list',
		component: () => import('@/views/agency/contract-templates/list.vue'),
		meta: { layout: 'content', module: 'MGAG,creator-hub' },
	},
	{
		path: '/agency/contract-templates/new',
		name: 'agency-contract-templates-create',
		component: () => import('@/views/agency/contract-templates/form.vue'),
		meta: { layout: 'content', module: 'MGAG,creator-hub' },
	},
	{
		path: '/agency/contract-templates/edit/:id',
		name: 'agency-contract-templates-edit',
		component: () => import('@/views/agency/contract-templates/form.vue'),
		props: route => ({ id: route.params.id }),
		meta: { layout: 'content', module: 'MGAG,creator-hub' },
	},

	// Issued Contracts
	{
		path: '/agency/contracts',
		name: 'agency-contracts-list',
		component: () => import('@/views/agency/contracts/list.vue'),
		meta: { layout: 'content', module: 'MGAG,creator-hub' },
	},
	{
		path: '/agency/contracts/:id',
		name: 'agency-contracts-detail',
		component: () => import('@/views/agency/contracts/detail.vue'),
		props: route => ({ id: Number(route.params.id) }),
		meta: { layout: 'content', module: 'MGAG,creator-hub' },
	},
	{
		path: '/agency/electronic-signatures',
		name: 'agency-electronic-signatures',
		component: () => import('@/views/agency/electronic-signatures/index.vue'),
		meta: { layout: 'content', module: 'MGN,admin' },
	},

	// Campaign Rosters
	{
		path: '/agency/campaign-rosters',
		name: 'agency-campaign-rosters-list',
		component: () => import('@/views/agency/campaign-rosters/list.vue'),
		meta: { layout: 'content', module: 'MGAG,creator-hub' },
	},

	// Payment Orders
	{
		path: '/agency/payment-orders',
		name: 'agency-payment-orders-list',
		component: () => import('@/views/agency/payment-orders/list.vue'),
		meta: { layout: 'content', module: 'MGAG,creator-hub' },
	},

	// Casting prospecting & invitations (external creators)
	{
		path: '/agency/casting-prospects',
		name: 'agency-casting-prospects-list',
		component: () => import('@/views/agency/casting-prospects/list.vue'),
		meta: { layout: 'content', module: 'MGAG,creator-hub' },
	},
	{
		path: '/agency/creator-campaigns/new',
		name: 'agency-creator-campaigns-create',
		component: () => import('@/views/agency/creator-campaigns/form.vue'),
		meta: { layout: 'content', module: 'MGAG,creator-hub' },
	},
	{
		path: '/agency/creator-campaigns',
		name: 'agency-creator-campaigns-list',
		component: () => import('@/views/agency/creator-campaigns/list.vue'),
		meta: { layout: 'content', module: 'MGAG,creator-hub' },
	},
	{
		path: '/agency/creator-campaigns/:id/results',
		name: 'agency-creator-campaigns-results',
		component: () => import('@/views/agency/creator-campaigns/results.vue'),
		meta: { layout: 'content', module: 'MGAG,creator-hub' },
	},
]

export default creatorHub
